import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Warning: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path fill="currentColor" d="M15 18.25h2v-9h-2z" />
    <path
      fill="currentColor"
      d="M16 27C9.94 27 5 22.07 5 16 5 9.94 9.94 5 16 5a11 11 0 0 1 0 22m0-24a13.01 13.01 0 0 0 0 26 13.01 13.01 0 0 0 0-26"
    />
    <path
      fill="currentColor"
      d="M16.02 20a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
    />
  </Icon>
);
